import React, { Fragment, useContext, useRef, useState } from "react";

import { Container, Row, Col, Card, CardBody, Spinner } from "reactstrap";

import { Contacts } from "../../../../Shared/Constants";

import { Breadcrumbs, Btn, ToolTip } from "../../../../AbstractElements";

import TableSearch from "../../../../Shared/Components/Search/TableSearch";
import ListHeader from "./ListHeader";
import ContactsTableData from "./ContactsTableData";
import { ContactContext, SocialDataContext } from "../../ContextProvider";
import { useNavigate } from "react-router";
import { PlusCircle } from "react-feather";
import { hasPermission } from "../../../../Shared/Utils/userUtils";

const Index = () => {
  const { setItem, setSearchTerm, exportMassive, selectedRows, selectImageSocialNetwork } = useContext(ContactContext);
  const [loadingButton, setLoadingButton] = useState(false)


  const navigate = useNavigate();
  const handleAddNew = (tab) => {
    setItem({});
    navigate(`${process.env.PUBLIC_URL}/app/contacts/add`);
  };

  const exportExcelRef = useRef(null);
  const updateImageRef = useRef(null);
  const [excelTooltipOpen, setExcelTooltipOpen] = useState(false);
  const toggleExcelTooltip = () => setExcelTooltipOpen(!excelTooltipOpen);
  const handleExportExcel = async () => {
    exportMassive();
  };

  const updateListContacts = async () => {
    setLoadingButton(!loadingButton)
    await selectImageSocialNetwork(selectedRows)
    setLoadingButton(false)


  }



  return (
    <Fragment>
      <Breadcrumbs title={Contacts} mainTitle={Contacts} parent="General" />
      <Container fluid={true} className="list-products">
        <Row>
          <ListHeader></ListHeader>

          <Col sm="12">
            <Card>
              <CardBody>
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8">
                    {hasPermission("create_contact") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleAddNew,
                          }}
                        >
                          <PlusCircle /> Crear nuevo contacto
                        </Btn>
                        <Btn
                          ref={exportExcelRef}
                          attrBtn={{
                            innerRef: exportExcelRef,
                            color: "outline-light",
                            className: "btn btn-light ",
                            onClick: handleExportExcel,
                            style: { "margin-right": "5px" },
                          }}
                        >
                          <i
                            className="fa fa-file-excel-o  "
                            style={{
                              "margin-right": "10px",
                            }}
                          ></i>{" "}
                          Exportar
                        </Btn>
                        <ToolTip
                          attrToolTip={{
                            placement: "top",
                            target: exportExcelRef,
                            isOpen: excelTooltipOpen,
                            toggle: toggleExcelTooltip,
                          }}
                        >
                          Exportar a excel
                        </ToolTip>

                        {selectedRows.length > 0 ? <Btn
                          ref={updateImageRef}
                          attrBtn={{
                            innerRef: updateImageRef,
                            color: "outline-light",
                            className: "btn btn-light gap-2 ",
                            onClick: updateListContacts,
                            style: { "margin-right": "5px" },
                          }}
                        >
                          {loadingButton && <Spinner size="sm">
                            Loading...
                          </Spinner>}

                          Actualizar imagen
                        </Btn> : null}

                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <ContactsTableData
                      showDeleteButton={true}
                      showEditButton={true}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Index;
